import { MenuDivider } from '@chakra-ui/react'

export default MenuDivider
